import { useGiftItem } from '@hooks/businessContainer';
import Link from 'next/link';
import { useTranslations } from 'next-intl';
import { useAuthentication } from '@context/businessContainer';

interface ICompleteRegistrationProps {
  label?: string;
}

const CompleteRegistration: React.FC<ICompleteRegistrationProps> = ({
  label,
}) => {
  const { isMemberProspect, isAuthenticated } = useAuthentication();
  const { addGiftItemToShoppingCart } = useGiftItem();
  const tAccount = useTranslations('Account');

  return (
    <Link
      href="/account/register/flow"
      rel="nofollow"
      data-testid="CompleteRegistration-go-to-account-register-flow"
      className="tw-lf-button tw-lf-button-primary tw-lf-button-md"
      onClick={addGiftItemToShoppingCart}
    >
      {isAuthenticated && isMemberProspect
        ? label || tAccount('finishSubscription')
        : tAccount('startTrial')}
    </Link>
  );
};

export default CompleteRegistration;
